import { today, addDays, num } from "@/lib/docOptions";
import { DocDialog } from "@/components/docs/DocDialog";
import { F, Section, PartyFields } from "@/components/docs/Fields";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const empty = () => ({
  title: "", portfolio_id: null, form_date: today(), owner: {}, listing_type: "SALE", property_type: "", city: "", district: "", neighborhood: "",
  address: "", rooms: "", area_m2: "", floor: "", ada: "", parsel: "", deed_info: "", asking_price: "", auth_start: today(), auth_end: addDays(90),
  exclusive: false, commission_rate: 2, notes: "",
});

const normalize = (f) => ({ ...f, area_m2: num(f.area_m2), asking_price: num(f.asking_price), commission_rate: num(f.commission_rate) ?? 0 });

export const RegFormForm = (props) => (
  <DocDialog {...props} kind="reg-forms" heading="Kayıt formu" empty={empty} normalize={normalize}>
    {(f, set) => (
      <>
        <Section title="Mal sahibi"><PartyFields prefix="regform-owner" value={f.owner} onChange={(v) => set({ owner: v })} /></Section>
        <Section title="Taşınmaz">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            <div>
              <Label className="text-xs">İşlem türü</Label>
              <Select value={f.listing_type} onValueChange={(v) => set({ listing_type: v })}>
                <SelectTrigger data-testid="regform-listing-type"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="SALE">Satılık</SelectItem><SelectItem value="RENT">Kiralık</SelectItem></SelectContent>
              </Select>
            </div>
            <F label="Taşınmaz tipi" testid="regform-property-type" value={f.property_type} onChange={(v) => set({ property_type: v })} />
            <F label="Oda" value={f.rooms} onChange={(v) => set({ rooms: v })} />
            <F label="Alan (m²)" type="number" value={f.area_m2} onChange={(v) => set({ area_m2: v })} />
            <F label="İl" testid="regform-city" value={f.city} onChange={(v) => set({ city: v })} />
            <F label="İlçe" testid="regform-district" value={f.district} onChange={(v) => set({ district: v })} />
            <F label="Mahalle" value={f.neighborhood} onChange={(v) => set({ neighborhood: v })} />
            <F label="Kat" value={f.floor} onChange={(v) => set({ floor: v })} />
            <F label="Açık adres" className="col-span-2" value={f.address} onChange={(v) => set({ address: v })} />
            <F label="Ada" value={f.ada} onChange={(v) => set({ ada: v })} />
            <F label="Parsel" value={f.parsel} onChange={(v) => set({ parsel: v })} />
            <F label="Tapu bilgileri" className="col-span-2" value={f.deed_info} onChange={(v) => set({ deed_info: v })} />
            <F label="İstenen bedel (TL)" type="number" testid="regform-price" value={f.asking_price} onChange={(v) => set({ asking_price: v })} />
          </div>
        </Section>
        <Section title="Yetki">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 items-end">
            <F label="Form tarihi" type="date" value={f.form_date} onChange={(v) => set({ form_date: v })} />
            <F label="Yetki başlangıç" type="date" value={f.auth_start} onChange={(v) => set({ auth_start: v })} />
            <F label="Yetki bitiş" type="date" testid="regform-auth-end" value={f.auth_end} onChange={(v) => set({ auth_end: v })} />
            <F label="Hizmet bedeli %" type="number" value={f.commission_rate} onChange={(v) => set({ commission_rate: v })} />
            <label className="flex items-center gap-2 text-sm col-span-2"><Switch data-testid="regform-exclusive" checked={f.exclusive} onCheckedChange={(v) => set({ exclusive: v })} />Münhasır (tek yetkili)</label>
          </div>
          <F label="Notlar" area value={f.notes} onChange={(v) => set({ notes: v })} />
        </Section>
      </>
    )}
  </DocDialog>
);
